export default class AppMediaModal {
    constructor () {
        this.load();
        this.init();
    }

    load () {
        this.$modals = $('.modal-media').filter(function () {
            return !$(this).parent().hasClass('d-none');
        });

        if (
          this.$modal === null
          || this.$modals.index(this.$modal) < 0
        ) {
            $('.modal-media').hide();
            this.hide();
        }
    }

    init () {
        let self = this;
        $('[data-media-modal]').on('click', function () {
            let $trigger = $(this);
            let selector = $trigger.attr('data-media-modal');
            self.show($(selector));
        });
        this.$modals.find('.modal-media-close').on('click', function (e) {
            e.preventDefault();
            self.hide();
        });
        this.$modals.find('.modal-media-prev').on('click', function (e) {
            e.preventDefault();
            self.prev();
        });
        this.$modals.find('.modal-media-next').on('click', function (e) {
            e.preventDefault();
            self.next();
        });
        this.$modals.on('click', function (e) {
            let $target = $(e.target);
            if ($target.hasClass('modal-media')) {
                self.hide();
            }
        });
        $(document).on('keydown', this.keyListener.bind(this));

        this.$modals.find('.modal-media-content').swipe({
            swipeRight: function () {
                self.prev();
            },
            swipeLeft: function () {
                self.next();
            },
        });
    }

    show ($modal) {
        this.$modals.hide();

        let $modalContent = $modal.find('.modal-media-content');

        let image = new Image();
        image.onload = function () {
            $modalContent.css('width', image.width);
        };
        image.src = $modalContent.find('img').attr('src');
        if (image.complete) {
            $modalContent.css('width', image.width);
        }

        this.$modal = $modal;
        $modal.show();
        $('body').css('overflow', 'hidden');
        this.open = true;
    }

    hide () {
        $('body').css('overflow', '');
        this.$modals.hide();
        this.$modal = null;
        this.open = false;
    }

    prev () {
        let index = this.$modals.index(this.$modal) - 1;
        if (index < 0) {
            index = this.$modals.length - 1;
        }
        this.show(this.$modals.eq(index));
    }

    next () {
        let index = this.$modals.index(this.$modal) + 1;
        if (index > this.$modals.length - 1) {
            index = 0;
        }
        this.show(this.$modals.eq(index));
    }

    keyListener (e) {
        if (this.open) {
            let event = e || window.event;

            switch (event.keyCode) {
            case 27: // escape
                this.hide();
                break;
            case 37: // left arrow
                this.prev();
                break;
            case 39: // right arrow
                this.next();
                break;
            }
        }
    }

    clearListener () {
        this.$modals.find('.modal-media-close').off('click');
        this.$modals.find('.modal-media-prev').off('click');
        this.$modals.find('.modal-media-next').off('click');
        this.$modals.off('click');
        $(document).off('keydown', this.keyListener);
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/mediaModal.js